$(function() {

    /*Testimonials*/
    let $cards = $(".testimonials .col .card");
    let totalCards = $cards.length;
    $cards.hide().slice(0, 4).show();
    if (totalCards > 4) {
        $("#btnloadmore").show();
    }
    $("#btnloadmore").on("click", function () {
        let currentlyVisible = $cards.filter(":visible").length;
        $cards.slice(currentlyVisible, currentlyVisible + 4).slideDown();
        if ($cards.filter(":visible").length >= totalCards) {
            $(this).fadeOut();
        }
    });


    /*Admissions dates*/
    $('#nextyear').on('change', function () {
        if ($(this).is(':checked')) {
            $('#currentyeardates').hide();
            $('#nextyeardates').show();
            $('#currentyear').prop('checked', false);
            $('.optionsslider').slick('setPosition');
        } else {
            $('#nextyeardates').hide();
            $('#currentyeardates').show();
            $('#currentyear').prop('checked', true);
        }
    });
    $('#currentyear').on('change', function () {
        if ($(this).is(':checked')) {
            $('#currentyeardates').show();
            $('#nextyeardates').hide();
            $('#nextyear').prop('checked', false);
            $('.optionsslider').slick('setPosition');
        }
    });



    $('.iconsearch').click(function() {
        //$('.openmenu').removeClass('active');
        $('#bt').removeClass('menuon');
        $('#sidenav').css('width', '0px');
        $('.hdrsearch').slideToggle(200);
        $('.outer').toggleClass('searchon');
        return false;
    });

    $('.faqq p').click(function() {
        $(this).closest('.faqq').next('.faqa').toggleClass('open').slideToggle(200);
        $(this).toggleClass('open');
        return false;
    });

    $('.htabslider').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });
    $('.heroslider').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        autoplaySpeed: 6000,
        speed: 1000
    });

    $('.imgcontentslider').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        fade: true,
        autoplaySpeed: 6000,
        speed: 1000
    });

    $('.slider1').on('setPosition', function(){
        setEqualHeights();
    });
    $(window).on('resize', setEqualHeights);
    setEqualHeights();

    $('.slider1').slick({
        autoplay: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        fade: true,
        autoplaySpeed: 6000,
        speed: 1000
    });

    $('.slider2, .slider3, .slider4').on('init reInit afterChange', function(event, slick) {
        if (slick.slideCount > slick.options.slidesToShow) {
            $(this).css('padding-bottom', '4rem');
        }
    });
    $('.slider2').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 680,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });

    $('.slider3').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 680,
                settings: {
                    centerMode: true,
                    centerPadding: '0', //was 60px;
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });

    $('.slider4').slick({
        autoplay: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    centerMode: true,
                    centerPadding: '60px',
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                }
            }
        ]
    });

    const slideroptions = {
        autoplay: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 992,
                settings: "unslick"
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            }
        ]
    };
    var optionsslick = $('.optionsslider');
    optionsslick.slick(slideroptions);
    $(window).resize(function () {
        setTimeout(function () {
            if($(window).width() < 993 && ! optionsslick.hasClass("slick-initialized")) {
                optionsslick.slick(slideroptions);
            }
        }, 100);
    });

    const timelineslideroptions = {
        autoplay: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 600,
                settings: "unslick"
            }
        ]
    };
    var timelineoptionsslick = $('.timelineslider');
    timelineoptionsslick.slick(timelineslideroptions);
    $(window).resize(function () {
        setTimeout(function () {
            if($(window).width() < 769 && ! timelineoptionsslick.hasClass("slick-initialized")) {
                timelineoptionsslick.slick(timelineslideroptions);
            }
        }, 100);
    });

    $(window).on('resize', function () {
        $('.slider2, .slider3, .slider4').on('init reInit afterChange', function(event, slick) {
            if (slick.slideCount > slick.options.slidesToShow) {
                $(this).css('padding-bottom', '4rem');
            } else {
                $(this).css('padding-bottom', '0');
            }
        });
    });

    $('.imggrid').imagesLoaded(function() {
        $('.imggrid').masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 20
        })
    });

    $(function() {
        const $overlay = $('#popupOverlay');
        const $popupBody = $('#popupBody');

        // Open popup
        $('.openform').on('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();

            const formId = $(this).data('form');
            const $formContent = $('#' + formId);

            if ($formContent.length) {
                $popupBody.html($formContent.html());
                $overlay.addClass('show');

                // Set the click events
                let $form = $popupBody.find('form');
                let siteKey = $form.attr('data-recaptcha-site-key');

                $form.find('.g-recaptcha').each(function() {
                    $(this).on('click', function() {
                        recaptchaForm = $form;
                    });
                });

                // (re)load the recaptcha script
                $.getScript('https://www.google.com/recaptcha/enterprise.js?render=' + siteKey);

            }
        });

        $('.popup-dtlhdr, #popupOverlay').on('click', function(e) {
            //if ($(e.target).is('#popupOverlay') || $(e.target).is('.popup-dtlhdr, .popup-dtlhdr *')) {
            if ($(e.target).is('.popup-dtlhdr, .popup-dtlhdr *')) {
                $overlay.removeClass('show');
                $popupBody.empty();
            }
        });
    });

    $('.mpvideo').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
    });


    $(".fitvids-wrapper").fitVids();

});

function setEqualHeights() {
    const breakpoint = 768;
    $(".studenttestimonials .featuretxttxt").css("height", "auto");
    if ($(window).width() >= breakpoint) {
        let maxHeight = 0;
        $(".studenttestimonials .featuretxttxt").each(function() {
            let thisHeight = $(this).outerHeight();
            if (thisHeight > maxHeight) {
                maxHeight = thisHeight;
            }
        });
        $(".studenttestimonials .featuretxttxt").css("height", maxHeight + "px");
    }
}

$(function () {
    const $container = $('#timeline-content');
    const $sections = $('.year-range');
    const $links = $('.timeline-nav a');

    $('.timeline-nav a').on('click', function (e) {
        e.preventDefault();

        const targetId = $(this).data('target');
        const $target = $('#' + targetId);

        if ($target.length) {
            const scrollTop = $target.offset().top - $container.offset().top + $container.scrollTop();
            $container.stop().animate({ scrollTop }, 600);
        }
    });


    function updateActiveLink() {
        const scrollTop = $container.scrollTop();
        let currentId = null;

        $sections.each(function () {
            const $section = $(this);
            const sectionTop = $section.offset().top - $container.offset().top + $container.scrollTop();

            if (sectionTop - 1 <= scrollTop) {
                currentId = $section.attr('id');
            }
        });

        if (currentId) {
            $links.removeClass('active');
            $links.filter('[data-target="' + currentId + '"]').addClass('active');
        }
    }

    $container.on('scroll', function() {
        updateActiveLink();
    });
    updateActiveLink();

    function filterOpenDays() {
        $('.opendays').each(function() {
            let $section = $(this);
            let $filters = $section.find('.newsfilters input[type=checkbox]');
            let $items = $section.find('.newsitem');
            let $noResults = $section.find('.no-results');

            if ($noResults.length === 0) {
                $noResults = $('<p class="no-results" style="display:none;">No upcoming open days match your selection.</p>');
                $section.find('.newslist').before($noResults);
            }

            $filters.on('change', function() {
                let selected = [];

                $filters.filter(':checked').each(function() {
                    selected.push($(this).data('slug'));
                });

                if (selected.length === 0) {
                    $items.show();
                } else {
                    $items.each(function () {
                        let $item = $(this);
                        let matches = selected.some(function(slug) {
                            return $item.hasClass(slug);
                        });
                        $item.toggle(matches);
                    });
                }

                let visibleCount = $items.filter(':visible').length;
                $noResults.toggle(visibleCount === 0);
            });

            // trigger initial filter once
            $filters.trigger('change');
        });
    }
    filterOpenDays();

    $(function() {
        $('.form-field').each(function() {
            if ($(this).find('button').length) {
                $(this).addClass('btnrow');
            }
            if ($(this).find('input[type="checkbox"]').length) {
                $(this).addClass('checkboxrow');
            }
        });
    });

});


